export default __webpack_public_path__ + "static/media/Atendimento (Real Size).12e76c6f.svg";